/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getUsers } from 'app/shared/reducers/user-management';
import { getEntities as getContactDetails } from 'app/entities/contact-details/contact-details.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacist.reducer';

export const PharmacistUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const contactDetails = useAppSelector(state => state.contactDetails.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacistEntity = useAppSelector(state => state.pharmacist.entity);
  const loading = useAppSelector(state => state.pharmacist.loading);
  const updating = useAppSelector(state => state.pharmacist.updating);
  const updateSuccess = useAppSelector(state => state.pharmacist.updateSuccess);
  const genderValues = Object.keys(Gender);
  const bloodGroupValues = Object.keys(BloodGroup);

  const handleClose = () => {
    navigate(`/pharmacist${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
    dispatch(getContactDetails({}));
    dispatch(getPharmacies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.age !== undefined && typeof values.age !== 'number') {
      values.age = Number(values.age);
    }
    if (values.dateOfBirth !== undefined && typeof values.dateOfBirth !== 'number') {
      values.dateOfBirth = Number(values.dateOfBirth);
    }

    const entity = {
      ...pharmacistEntity,
      ...values,
      tmUser: users.find(it => it.id.toString() === values.tmUser?.toString()),
      contactCode: contactDetails.find(it => it.id.toString() === values.contactCode?.toString()),
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          gender: 'NA',
          bloodGroup: 'O_POS',
          ...pharmacistEntity,
          tmUser: pharmacistEntity?.tmUser?.id,
          contactCode: pharmacistEntity?.contactCode?.id,
          pharmacy: pharmacistEntity?.pharmacy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacist.home.createOrEditLabel" data-cy="PharmacistCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacist.home.createOrEditLabel">Create or edit a Pharmacist</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacist-id"
                  label={translate('tinyMedicRestApp.pharmacist.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.education')}
                id="pharmacist-education"
                name="education"
                data-cy="education"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.training')}
                id="pharmacist-training"
                name="training"
                data-cy="training"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.experience')}
                id="pharmacist-experience"
                name="experience"
                data-cy="experience"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.achievements')}
                id="pharmacist-achievements"
                name="achievements"
                data-cy="achievements"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.timestampentry')}
                id="pharmacist-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.microSec')}
                id="pharmacist-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.lastupdated')}
                id="pharmacist-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.active')}
                id="pharmacist-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.cursor')}
                id="pharmacist-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.name')}
                id="pharmacist-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.email')}
                id="pharmacist-email"
                name="email"
                data-cy="email"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.age')}
                id="pharmacist-age"
                name="age"
                data-cy="age"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.gender')}
                id="pharmacist-gender"
                name="gender"
                data-cy="gender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.mobile')}
                id="pharmacist-mobile"
                name="mobile"
                data-cy="mobile"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.dateOfBirth')}
                id="pharmacist-dateOfBirth"
                name="dateOfBirth"
                data-cy="dateOfBirth"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacist.bloodGroup')}
                id="pharmacist-bloodGroup"
                name="bloodGroup"
                data-cy="bloodGroup"
                type="select"
              >
                {bloodGroupValues.map(bloodGroup => (
                  <option value={bloodGroup} key={bloodGroup}>
                    {translate(`tinyMedicRestApp.BloodGroup.${bloodGroup}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="pharmacist-tmUser"
                name="tmUser"
                data-cy="tmUser"
                label={translate('tinyMedicRestApp.pharmacist.tmUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacist-contactCode"
                name="contactCode"
                data-cy="contactCode"
                label={translate('tinyMedicRestApp.pharmacist.contactCode')}
                type="select"
              >
                <option value="" key="0" />
                {contactDetails
                  ? contactDetails.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacist-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacist.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacist" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacistUpdate;
